import Comm from './comm';
// import Util from './util';
import Modules from './modules';

export default class API {
    constructor(gb) {
        Object.assign(this, { gb, settings: gb.settings });

        if (!gb.settings.socketUrl) {
            alert("GameBridge can't start! No server set - set 'socketUrl'!");
            return;
        }
        this.drawer = null;

        this.languageCode = gb.settings.languageCode || "ENG";
        this.cageCode = gb.settings.cageCode;
        if (gb.settings.playerId) {
            this.playerId = gb.settings.playerId;
        }

        this.realPlayer = !!gb.settings.playerId || !!gb.settings.token;

        this.modules = new Modules(this);
        this.util = gb.utils; //new Util(this, settings);
        this.queryParams = this.util.getQueryParams();

        this.comm = new Comm(this, gb.settings);
    }

    /*leaderboard(container, instance, widgetSettings) {
        if (!window.Widget_leaderboard) {
            console.error("No widget_leaderboard.js component found registered ... did you include it in the HTML? Could also be a race condition problem - widget_leaderboard.js needs to be loaded before widget_api.js.");
            return;
        }

        new window.Widget_leaderboard.default(this.settings, container, this.queryParams.leaderboardCode || instance, this, widgetSettings);
    }

    jackpots(container, instance, widgetSettings) {
        if (!window.Widget_jackpots) {
            console.error("No widget_jackpots.js component found registered ... did you include it in the HTML? Could also be a race condition problem - widget_jackpot.js needs to be loaded before widget_api.js.");
            return;
        }

        new window.Widget_jackpots.default(this.settings, container, this.queryParams.jackpotsCode || instance, this, widgetSettings);
    }*/
}
